import { merge } from '../../helper';

import * as exUtils from './utils';

// ----------------------------------------------------------------------------

export type TypeRequestConfigEvent = ProgressEvent;

export type TypeRequestInterceptorConfig = {
    merge?: any;
    fnError?: (this: XMLHttpRequest, data: Record<string, any> | undefined, evt: TypeRequestConfigEvent) => void;
    fnSuccess?: (this: XMLHttpRequest, data: Record<string, any> | undefined, evt: TypeRequestConfigEvent) => void;
};

// ----------------------------------------------------------------------------

let currentConfig: TypeRequestInterceptorConfig = {};
let originalSend: typeof XMLHttpRequest.prototype.send | null = null;

// ----------------------------------------------------------------------------

function isActive(): boolean {
    return originalSend !== null;
}

function stop(): void {
    if (originalSend == null) {
        return;
    }

    XMLHttpRequest.prototype.send = originalSend;
    originalSend = null;
    currentConfig = {};
}

function start(config: TypeRequestInterceptorConfig = {}): () => void {
    const defConfig: TypeRequestInterceptorConfig = {};

    merge(defConfig, config);

    // ------------------------------------------------------------------------

    currentConfig = defConfig;

    if (originalSend != null) {
        return stop;
    }

    originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.send = function (this: XMLHttpRequest, ...args): void {
        const onload = this.onload;
        const onerror = this.onerror;

        this.onload = function (this: XMLHttpRequest, evt: TypeRequestConfigEvent): void {
            if (this.readyState === XMLHttpRequest.DONE) {
                const data = exUtils.getResponse(this);

                if (this.status >= 200 && this.status < 300) {
                    currentConfig.fnSuccess?.call(this, data, evt);
                } else {
                    currentConfig.fnError?.call(this, data, evt);
                }
            }

            if (typeof onload === 'function') {
                onload.call(this, evt);
            }
        };

        this.onerror = function (this: XMLHttpRequest, evt: TypeRequestConfigEvent): void {
            const data = exUtils.getResponse(this);

            currentConfig.fnError?.call(this, data, evt);

            if (typeof onerror === 'function') {
                onerror.call(this, evt);
            }
        };

        originalSend?.apply(this, args);
    };

    return stop;
}

function send(config: TypeRequestInterceptorConfig = {}): () => void {
    return start(config);
}

// ----------------------------------------------------------------------------

export { isActive, send, start, stop };
